import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Map, BookOpen, Image, Users } from "lucide-react";
import { fetchAPI } from "@/lib/api";

interface DashboardStats {
  inquiries: number;
  circuits: number;
  stories: number;
  gallery: number;
}

const AdminDashboard = () => {
  const [stats, setStats] = useState<DashboardStats>({
    inquiries: 0,
    circuits: 0,
    stories: 0,
    gallery: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAPI("?type=dashboard_stats")
      .then((data: any) => {
        setStats(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching stats:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading dashboard...</div>;
  }

  const statCards = [
    { title: "Total Inquiries", value: stats.inquiries, icon: Users, color: "text-blue-500" },
    { title: "Active Circuits", value: stats.circuits, icon: Map, color: "text-green-500" },
    { title: "Published Stories", value: stats.stories, icon: BookOpen, color: "text-purple-500" },
    { title: "Gallery Items", value: stats.gallery, icon: Image, color: "text-orange-500" },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-serif font-bold text-foreground">Dashboard</h1>
        <p className="text-muted-foreground mt-2">Overview of your platform's performance.</p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {statCards.map((stat, index) => (
          <Card key={index} className="shadow-sm">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">
                {stat.title}
              </CardTitle>
              <stat.icon className={`h-4 w-4 ${stat.color}`} />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
